export { default as SearchInput } from './searchInput';
export { searchInputStandard } from './__fixtures__/searchInput';
